import { Link } from "react-router-dom";
import type { MediaItem } from "@/mocks/media";

interface MediaCardProps {
  item: MediaItem;
}

export default function MediaCard({ item }: MediaCardProps) {
  return (
    <Link to={`/detail/${item.id}`} className="group block">
      <div className="relative aspect-[2/3] w-full overflow-hidden rounded-lg bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title} 海报`}
          title={`${item.title} - 麻豆精品影视`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 bottom-0 h-14 bg-gradient-to-t from-foreground-950/80 to-transparent"></div>
        <span className="absolute left-2 top-2 rounded-md bg-primary-500/90 px-2 py-0.5 text-[11px] font-semibold text-background-50">
          {item.type === "movie" ? "电影" : "剧集"}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-foreground-950/70 px-2 py-0.5 text-[11px] font-bold text-accent-300">
          <i className="ri-star-fill text-[10px]" aria-hidden="true"></i>
          {item.rating.toFixed(1)}
        </span>
      </div>
      <h3 className="mt-2.5 truncate text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
        {item.title}
      </h3>
      <p className="mt-1 truncate text-xs text-foreground-500">
        {item.genres.join(" · ")} · {item.year}
      </p>
    </Link>
  );
}